import {NAME} from './constants';

export const getAds = state => state[NAME].settings.ads;
export const getPreviews = state => state[NAME].settings.previews;
export const areSettingsValid = state => state[NAME].settings.valid;
export const getSelectedAd = state => state[NAME].settings.selectedAd;
export const getStoreSettings = state => state[NAME].settings.store;

export const areCareSheetsValid = state => state[NAME].valid;

export const getPetTypes = state => state[NAME].search.petTypes;
export const getSelectedPetTypes = state => state[NAME].search.selectedPetTypes;
export const getSearchResults = state => state[NAME].search.results;
export const getSearchPhrase = state => state[NAME].search.phrase;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/selectors.js
 **/